import _ from "lodash";
import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { Link, useParams, useRouteMatch } from "react-router-dom";
import { PageTitle } from "components/standart";

import IntlMessages from "util/intlMessages";
import { LoadingIcon, setOnChange } from "components/special";
import { Alert } from "reactstrap";
import { AudioPreview, Uploader } from "components/standart";

import { adminAPI } from "redux/api";
import { SwitchValue } from "components/special/forms";

import { apiUrls } from "../init";

const { api } = adminAPI.actions;

const ContentForm = (props) => {
  const { url } = useRouteMatch();
  const { breadCrumbs, content, setContent } = props;
  const params = useParams();
  const [dataSaved, setDataSaved] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const changeContent = setOnChange(content, setContent);
  breadCrumbs.push({
    title: <IntlMessages id="Replacements.Form" />,
    url,
  });

  const successAlertRef = useRef(null);

  const saveHandler = () => {
    const onSuccess = (body) => {
      setContent(body);
      setDataSaved(true);
      successAlertRef.current.scrollIntoView();
    };

    const onRequest = () => {
      setDataSaved(false);
    };

    const onFailure = () => {
      setDataSaved(false);
    };

    props.saveContent({ params, body: content }, { onSuccess, onFailure, onRequest });
  };

  const changeVolumeHandler = () => {
    const onSuccess = (body) => {
      setContent({ ...content, volumeFileId: body._id });
      setLoading(false);
    };

    const onRequest = () => {
      setContent({ ...content, volumeFileId: null });
      setLoading(true);
    };

    const onFailure = () => {
      setLoading(false);
    };

    props.changeVolume({ params, body: content }, { onSuccess, onFailure, onRequest });
  };

  return (
    <div>
      <PageTitle {...breadCrumbs} />

      <div className="row">
        <div className="col-12">
          <div className="roe-card-style">
            <div className="roe-card-body">
              <div ref={successAlertRef}>
                <Alert
                  className="alert-success"
                  isOpen={dataSaved}
                  toggle={() => setDataSaved(false)}
                >
                  <IntlMessages id="saved" />
                </Alert>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Backgrounds.name" />
                </label>
                <div className="col-8">
                  <input
                    type="text"
                    name="name"
                    value={content.name || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Backgrounds.originFileId" />
                  <Uploader
                    className="btn-success btn-sm pull-right"
                    successHandler={([file]) => setContent({ ...content, originFileId: file._id })}
                    accept="*.mp3"
                    multiple={false}
                  />
                </label>
                <div className="col">
                  {content.originFileId && (
                    <AudioPreview
                      file={{ _id: content.originFileId }}
                      deleteHandler={() => {
                        setContent({ ...content, originFileId: null });
                      }}
                    />
                  )}
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Backgrounds.volume" />
                </label>
                <div className="col-4">
                  <input
                    type="number"
                    name="volume"
                    value={content.volume || ""}
                    onChange={changeContent}
                    className="form-control react-form-input"
                    autoComplete="off"
                    required
                  />
                </div>
                <div className="col">
                  <button className="btn btn-sm btn-warning" onClick={changeVolumeHandler}>
                    Применить громкость
                  </button>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="Sounds.Backgrounds.volumeFileId" />
                  <Uploader
                    className="btn-success btn-sm pull-right"
                    successHandler={([file]) => setContent({ ...content, volumeFileId: file._id })}
                    accept="*.mp3"
                    multiple={false}
                  />
                </label>
                <div className="col">
                  {isLoading ? <LoadingIcon /> : null}

                  {content.volumeFileId && (
                    <AudioPreview
                      file={{ _id: content.volumeFileId }}
                      deleteHandler={() => {
                        setContent({ ...content, volumeFileId: null });
                      }}
                    />
                  )}
                </div>
              </div>

              <div className="form-group row">
                <label className="col-4 col-form-label">
                  <IntlMessages id="tables.enabled" />
                </label>
                <div className="col-8 my-auto">
                  <SwitchValue value={content.enabled} onChange={changeContent} />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-4 col-auto">
                  <button className="form-control c-primary" type="button" onClick={saveHandler}>
                    <IntlMessages id="save" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const FormButton = (props) => {
  const { contentForm, content } = props;
  return (
    <Link to={contentForm(content)} className="btn btn-secondary btn-sm">
      <i className="fa fa-edit" />
    </Link>
  );
};

export default connect(null, {
  saveContent: api.put(apiUrls.backgroundsInfo),
  changeVolume: api.post(apiUrls.backgroundsVolume),
})(ContentForm);
